import { render } from "./Tool.vue?vue&type=template&id=5f62f37c&ts=true"
import script from "./Tool.vue?vue&type=script&lang=ts"
export * from "./Tool.vue?vue&type=script&lang=ts"

import "./Tool.vue?vue&type=style&index=0&id=5f62f37c&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__